export * from "./ChipTemplate";
export { default as ChipTemplate } from "./ChipTemplate";
